import React from 'react';
import { ReactComponent as BackIcon } from 'assets/icons/back_arrow.svg';
import styles from './header.module.scss';
import { CompanySetupEnum } from 'enums/CompanySetupEnums';
import COButton from 'shared/components/COButton';
import { ButtonSize } from 'enums/ButtonEnums';
import { ArrowRightOutlined } from '@ant-design/icons';
import AddIcon from 'assets/images/add_blue_bg.png';
import useFilters from 'shared/hooks/useFilters';
import { params, processingFacility } from 'constants/constants';
import useRedirect from 'shared/utils/useRedirect';

interface HeadingSectionProps {
  push: (location: {
    name: string;
    category?: string;
    city: string;
    street: string;
    country: string;
    province: string;
    postalCode: string;
    belongs?: string;
    latitude: string;
    longitude: string;
    countryCode: string;
  }) => void;
  fetchingAddress: boolean;
}

const HeadingSection: React.FC<HeadingSectionProps> = ({
  push,
  fetchingAddress,
}) => {
  const { getParams } = useFilters();
  const { navigateBack } = useRedirect();
  const { isProcessingFacility: isPrefill, belongsId } = getParams(params);
  const handlePush = () => {
    push({
      name: '',
      category: isPrefill ? processingFacility : undefined,
      city: '',
      street: '',
      country: '',
      province: '',
      postalCode: '',
      belongs: belongsId ? String(belongsId) : undefined,
      latitude: '',
      longitude: '',
      countryCode: '',
    });
  };
  return (
    <div className={styles.headingContainer}>
      <div className={styles.titleContainer}>
        <div className={styles.iconWrapper} onClick={navigateBack}>
          <BackIcon />
        </div>
        <div className={styles.locationTitle}>{CompanySetupEnum.NEW}</div>
      </div>
      <div className={styles.buttonContainer}>
        <div className={styles.addLocation} onClick={handlePush}>
          <img src={AddIcon} className={styles.imgAdd} alt="Add" />
          <span>{CompanySetupEnum.ADD_LOCATION}</span>
        </div>

        <COButton
          primary
          size={ButtonSize.SMALL}
          submit
          loading={fetchingAddress}>
          <div className={styles.nextBtn}>
            {CompanySetupEnum.NEXT}
            <ArrowRightOutlined className={styles.arrowRight} />
          </div>
        </COButton>
      </div>
    </div>
  );
};

export default HeadingSection;
